import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Scalanie klas Tailwinda.
 *
 * `clsx` rozwija warunki, `tailwind-merge` usuwa konflikty — bez tego drugiego
 * `cn('p-2', 'p-4')` dawałoby obie klasy i wygrywałaby ta późniejsza
 * w arkuszu, a nie w wywołaniu. To właśnie ta funkcja pozwala komponentom mieć
 * domyślne klasy, które wywołujący może nadpisać przez `className`.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
